<!-- <app-main-layout [@routeAnimation]="o.isActivated ? o.activatedRoute : ''">
  <router-outlet #o="outlet"></router-outlet>
</app-main-layout> -->

<wm-libs-main-layout [app]="'wm-tech'">
  <router-outlet></router-outlet>
</wm-libs-main-layout>
